import { PLAYBACK_SPEEDS } from "./audio-context.constants";
import { AudioActions, IAudioReducer } from "./audio-context.types";

/**
 * Reducer for managing state changes for the audio context.
 * @param state - the estate of the audio context.
 * @param action - the action to be performed.
 * @returns The updated state after applying the action.
 */
export const audioReducer: IAudioReducer = (state, action) => {
    switch (action.type) {
        case AudioActions.LOAD_AUDIO:
            return {
                ...state,
                audioRef: action.payload.audioRef,
                url: action.payload.url,
            };
        case AudioActions.RESET_CONTEXT:
            return {
                ...state,
                ...action.payload,
            };
        case AudioActions.SET_CURRENT_TIME:
            return { ...state, currentTime: state.duration ? Math.min(action.payload, state.duration) : 0 };
        case AudioActions.SET_DURATION:
            return { ...state, duration: action.payload };
        case AudioActions.SET_ERROR:
            return { ...state, error: action.payload };
        case AudioActions.SET_IS_PLAYING:
            return { ...state, isPlaying: action.payload };
        case AudioActions.SET_IS_LOADING:
            return { ...state, isLoading: action.payload, error: action.payload ? null : state.error };
        case AudioActions.SET_IS_MUTED:
            return { ...state, isMuted: action.payload };
        case AudioActions.SET_PLAYBACK_RATE:
            return { ...state, playbackRate: PLAYBACK_SPEEDS.includes(action.payload) ? action.payload : 1 };
        case AudioActions.SET_VOLUME:
            return { ...state, volume: Math.max(0, Math.min(1, action.payload)) };
        default:
            return state;
    }
};
